import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TypesComponent } from './types/types.component';
import { RequestComponent } from './request/request.component';
import { RequestSubjectsComponent } from './request-subjects/request-subjects.component';
import { RequestSuccessComponent } from './request-success/request-success.component';
import { DocumentsReceptionComponent } from './documents-reception/documents-reception.component';

const routes: Routes = [
  { path: 'solicitudes/tipo-disponibles', component: TypesComponent},
  { path: 'solicitudes', component: RequestComponent},
  { path: 'solicitudes/registro-asignaturas', component: RequestSubjectsComponent},
  { path: 'solicitudes/registro-asignaturas/existoso', component: RequestSuccessComponent},
  { path: 'solicitudes/recepcion-documentos', component: DocumentsReceptionComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RequetsRoutingModule { }
